import styled from "styled-components";
import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../../constants/Styles";

export const Warnings = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: flex-start;
  color: ${COLORS.secondary};
  font-size: ${FONT_SIZE.size14};
  font-weight: ${FONT_WEIGHT.weight500};
  width: 100%;
`;

export const IconContainer = styled.div`
  flex: 1;
  display: flex;
`;

export const MessageContainer = styled.div`
  flex: 10;
`;

export const WarningsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;
`;
